<template>
  <div class="hero relative" :class="fullScreen ? 'full-screen' : 'split-screen'">
    <badge class="color-pink badge--big bottom-right fs-12 badge-desktop">
      {{ $utils.constants.NEW_RETAILER_PROMO_CODE_OFFER_TEXT }}
    </badge>

    <img v-if="mobiImageUrl" class="hero-img hide show-sm" :src="`${mobiImageUrl}`" />
    <img v-if="imageUrl" class="hero-img hide-sm" :src="`${imageUrl}`" />
    <div class="content-container" :style="`backgroundColor: ${backgroundColor}; color: ${textColor}`">
      <div class="content-container--positionalWrapper">
        <div
          v-if="
            !user || (user && user.role !== 'RETAILER') || (user && user.role === 'RETAILER' && !showBulletinPlusHero)
          "
        >
          <h2 :key="line.value" v-for="line in title">
            {{ line.value }}
            <div
              class="
                size-28
                shadow
                mr-30
                absolute
                bottom-100
                right-0
                flex
                align-center
                justify-center
                border-radius-round
                bg-black
              "
            >
              <inline-svg
                class="size-16 fill-current-color color-white"
                :src="require('@/assets/img/icons/icon-heart-white.svg')"
              ></inline-svg>
            </div>
          </h2>
          <div class="by-line mt-30">
            <h4 :key="line.value" v-for="line in copy" class="line">
              {{ line.value }}
            </h4>
          </div>
          <div v-if="showSignUp">
            <bulletin-button
              variant="primary"
              name="sign-up-retailer"
              v-trackevent="{ action: 'Homepage Retailer Application Hero' }"
              @click="$router.push({ path: '/wholesale-retail/buyer' })"
              class="mx-10 inline-block mx-0-sm mr-10-sm px-10-sm min-width-150-sm"
              :class="textColor === 'white' ? 'button-transparent-white' : 'button-black'"
            >
              I'm a retailer
            </bulletin-button>
            <bulletin-button
              variant="primary"
              name="sign-up-brand"
              v-trackevent="{ action: 'Homepage Brand Application Hero' }"
              @click="$router.push({ path: '/wholesale-retail/brand' })"
              class="mx-10 inline-block mx-0-sm px-10-sm min-width-150-sm"
              :class="textColor === 'white' ? 'button-transparent-white' : 'button-black'"
            >
              I'm a brand
            </bulletin-button>
          </div>
          <div v-else>
            <bulletin-button
              v-if="feature"
              name="hero"
              class="mx-20 mb-20"
              :class="textColor === 'white' ? 'button-transparent-white' : 'button-transparent'"
              v-trackevent="{
                action: 'Homepage Hero Shop',
                properties: {
                  URL: feature.url,
                },
              }"
              @click="openFeaturedButtonLink()"
            >
              {{ feature.homepage_title }}
            </bulletin-button>
          </div>
        </div>

        <bulletin-plus v-if="user && user.role === 'RETAILER' && showBulletinPlusHero"></bulletin-plus>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "../../../assets/sass/base/vars.scss";
@import "../../../assets/sass/base/helpers.scss";
.support-store {
  .content-container {
    display: none !important;
  }
}
.hero {
  height: 550px;
  position: relative;

  @include respond-to("small") {
    height: unset;
  }

  &.full-screen {
    .content-container {
      position: absolute;
      left: 0%;
      top: 0px;
      height: 100%;
      width: 100%;

      @include respond-to("small") {
        display: flex;
        background: auto !important;
        align-items: center;
        .line {
          display: block;
        }

        padding: 10px 0;
      }
      @include respond-above("small") {
        background: transparent !important;
      }
    }
    .hero-img {
      object-fit: cover;
      object-position: center;
      height: 100%;
      width: 100%;
      @include respond-to("small") {
        background-position: center top;
        position: relative;
        height: 290px;
        width: 100%;
      }
    }
    .badge-desktop {
      @include respond-to("small") {
        display: none;
      }
    }
  }
  &.split-screen {
    .hero-img {
      object-fit: cover;
      object-position: center;
      height: 100%;
      width: 50%;
      @include respond-to("small") {
        object-position: center;
        background-position: center top;
        position: relative;
        height: 290px;
        width: 100%;
      }
    }
    .content-container {
      position: absolute;
      left: 50%;
      top: 0px;
      height: 100%;
      width: 50%;
      @include respond-to("small") {
        position: static;
        display: flex;
        width: 100%;
        top: 50%;
        height: 50%;
        left: 0px;
        align-items: center;
        .line {
          display: block;
        }
      }
    }
  }
  .content-container--positionalWrapper {
    text-align: center;
    position: relative;
    @include respond-to("small") {
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      width: 100%;
      margin: 40px 0;
    }
    @include respond-above("small") {
      margin: 0px auto;
      padding: 0 10px;
      width: 100%;
      max-width: 590px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
    .by-line {
      margin-top: 20px;
      margin-bottom: 40px;
      font-size: 18px;
      @include respond-to("small") {
        margin-top: 15px;
        margin-bottom: 15px;
        font-size: 12px;
      }
      letter-spacing: 0.2px;
      div {
        text-align: center;
      }
    }
  }
}
</style>
<script>
import InlineSvg from "vue-inline-svg";
import BulletinPlus from "../bulletinPlus/bulletinPlus.vue";
import { mapGetters } from "vuex";

export default {
  props: [
    "showSignUp",
    "fullScreen",
    "title",
    "copy",
    "feature",
    "imageUrl",
    "mobiImageUrl",
    "backgroundColor",
    "textColor",
  ],
  components: {
    InlineSvg,
    BulletinPlus,
  },
  methods: {
    openFeaturedButtonLink() {
      window.location.href = this.feature.url;
    },
  },
  computed: {
    isStickerVisible() {
      return this.user && this.user.role === "RETAILER";
    },

    showBulletinPlusHero() {
      // TODO uncomment next 2 lines to activate randomization
      // const number = Math.random();
      // return number > 0.5 ? true : false;
      return false;
    },
    ...mapGetters({
      user: "userState",
    }),
  },
};
</script>
